import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="profile"
export default class extends Controller {
  static override targets = ["avatarPreview", "fileInput", "fallback", "removeAvatarCheckbox"]

  declare readonly avatarPreviewTarget: HTMLImageElement
  declare readonly fileInputTarget: HTMLInputElement
  declare readonly hasAvatarPreviewTarget: boolean
  declare readonly hasFallbackTarget: boolean
  declare readonly fallbackTarget: HTMLElement
  declare readonly hasRemoveAvatarCheckboxTarget: boolean
  declare readonly removeAvatarCheckboxTarget: HTMLInputElement

  // Open the hidden file input when "Upload New Photo" is clicked
  triggerUpload() {
    this.fileInputTarget.click()
  }

  // Show a live preview of the selected file before the form is submitted
  previewAvatar() {
    const file = this.fileInputTarget.files?.[0]
    if (!file || !this.hasAvatarPreviewTarget) return

    const reader = new FileReader()
    reader.onload = (e) => {
      this.avatarPreviewTarget.src = e.target?.result as string
      this.avatarPreviewTarget.style.display = "block"
      // Hide the initial-letter fallback when the user picks a file for the first time
      if (this.hasFallbackTarget) {
        this.fallbackTarget.style.display = "none"
      }
    }
    reader.readAsDataURL(file)
  }

  // Check the hidden remove_avatar field then submit the avatar form
  removeAvatar() {
    if (this.hasRemoveAvatarCheckboxTarget) {
      this.removeAvatarCheckboxTarget.checked = true
    }
    (this.element as HTMLFormElement).requestSubmit()
  }
}
